import { render, staticRenderFns } from "./UIPopup.vue?vue&type=template&id=045ba4ba&scoped=true"
import script from "./UIPopup.vue?vue&type=script&lang=ts"
export * from "./UIPopup.vue?vue&type=script&lang=ts"
import style0 from "./UIPopup.vue?vue&type=style&index=0&id=045ba4ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045ba4ba",
  null
  
)

export default component.exports